import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ToastController, Events } from 'ionic-angular';

@Injectable()
export class CarrelloProvider {

	carrello = {}; // {id: qta, id: qta, ...}, dove id = id_prodotto-formato
	cartLoaded = false;
	
	constructor(private storage: Storage, private toastCtrl: ToastController, private events: Events) {}

	async loadCart(): Promise<any> {
		await this.storage.ready();
		const cart = await this.storage.get('carrello');
		cart && (this.carrello = cart);
		// console.log(this.carrello);
		this.cartLoaded = true;
	}

	async getQtaTotale(): Promise<any> {
		if (!this.cartLoaded) {
			await this.loadCart();
		}
		let qta = 0;
		for (let id in this.carrello) {
			qta += this.carrello[id];
		}
		return Promise.resolve(qta);
	}

	async salvaCarrello(): Promise<any> {
		await this.storage.set('carrello', this.carrello);
		return this.events.publish('cart:update');
	}

	aggiungi( id_prodotto: number, formato: string, qta: number ): Promise<any> {
		let id = this._crea_id( id_prodotto, formato );
		if( this.carrello.hasOwnProperty(id) ) {
			this.carrello[id] += qta;
		} else {
			this.carrello[id] = qta;
		}
		// this._notifica();
		return this.salvaCarrello();
	}

	rimuovi( id_prodotto: number, formato: string ): Promise<any> {
		let id = this._crea_id( id_prodotto, formato );
		if( this.carrello.hasOwnProperty(id) ) {
			delete this.carrello[id];
		}
		return this.salvaCarrello();
	}

	impostaQta( id_prodotto: number, formato: string, qta: number ): Promise<any> {
		let id = this._crea_id( id_prodotto, formato );
		if( qta == 0 ) {
			return this.rimuovi( id_prodotto, formato );
		} else {
			this.carrello[id] = qta;
			return this.salvaCarrello();
		}
	}

	reset(): Promise<any> {
		this.carrello = {};
		return this.salvaCarrello();
	}
	
	_crea_id( id_prodotto: number, formato: string ) {
		return id_prodotto + '-' + formato.replace(/\s+/g, '');
	}

	_notifica() {
		const toast = this.toastCtrl.create({
			message: 'Prodotto aggiunto',
			duration: 1000,
			position: 'bottom'
		});
		toast.present();
	}
}



// WEBPACK FOOTER //
// ./src/providers/carrello/carrello.ts